module.exports = __webpack_public_path__ + "img/building-regular.a7d53d3b.svg";